/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from 'react';
import DropdownSelect from './DropdownSelect';
import { supabase } from '../../lib/supabase';

export function IndustrySelect({
  onChange,
  value,
  disabled,
  isInvalid,
  full,
}: {
  onChange: (val: string | number | string[] | boolean | undefined) => void;
  value: string;
  disabled?: boolean;
  isInvalid?: boolean;
  full?: boolean;
}) {
  const [industries, setIndustries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndustries = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('industry_options')
        .select('id, label, score, ordinal')
        .order('ordinal', { ascending: true });

      if (error) {
        console.error('Error fetching industries:', error);
        setIndustries([]);
      } else {
        setIndustries(data ?? []);
      }

      setLoading(false);
    };

    fetchIndustries();
  }, []); // Runs only once

  if (loading || !industries.length) return null;

  return (
    <DropdownSelect
      options={industries.map((i: { id: string; label: string }) => ({
        id: i.id,
        label: i.label,
      }))}
      disabled={disabled}
      selectedIds={value}
      placeholder="Select industry"
      full={full}
      // @ts-expect-error: ts(2339)
      onValueChanged={(val) => onChange(val.id)} // Return UUID
      isInvalid={isInvalid}
    />
  );
}
